export enum EAiTextType {
    IMPROVE = 'improve',
    TONE = 'tone',
    LANG = 'lang',
    REPEAT = 'repeat',
    CUSTOM = 'custom',
}
